import { ExaminationRoom } from '@/pages/clinic/examinationRooms/columns'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export function useExaminationRoomById(id: number) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<ExaminationRoom>>(
    token ? `/api/examination-rooms/${id}` : null,
    undefined,
    token ?? '',
  )

  return {
    examinationRoom: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
